<template>
  <vx-card no-shadow>
    <div class="vx-row">
      <div class="vx-col w-full flex flex-col items-center my-5">
            <p class="my-6">Recibirás un correo en {{activeUserInfo.email}} con las instrucciones para cambiar tu contraseña.</p>
            <vs-button color="primary" type="filled" @click="recoverPassword">Solicitar cambio de contraseña</vs-button>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  data () {
    return {
      old_password: '',
      new_password: '',
      confirm_new_password: ''
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    activeEvolugyUserInfo () {
      return this.$store.state.EvolugyActiveUser
    }
  },
  methods: {
    recoverPassword (){
       
            const payload = {   
                email: this.activeUserInfo.email,
            }
            this.$store.dispatch('auth/sendPasswordRecoveryEmail', payload).then(() => {
                alert('Cambio de contraseña envíado satisfactoriamente.')
            })
    }
  }
}
</script>
